import React from "react";
import { standardClassNames, timestampToHourAndMinutes } from "../utils";
import { SlotKey } from "../utils/types";

export type Label = React.FC<{time: number}>

export const HourLabel: Label = ({ time }) => (
  <div className={`text-center`}>
    {timestampToHourAndMinutes(time)}
  </div>
);

export const DayDateLabel: Label = ({ time }) => (
  <div className={`text-center`}>
    {new Date(time).toLocaleDateString('en-us', { weekday: 'short', day: 'numeric' })}
  </div>
)

export const DayLabel: Label = ({ time }) => (
  <div className={`text-center`}>
    {new Date(time).toLocaleDateString('en-us', { weekday: 'short' })}
  </div>
)

